/**
 * Thank-you branding after a shared-funnel submit comes from the server:
 * the firm the lead was actually sent to, or none (generic thank-you page).
 */
export function routedThankYou(vertical, data) {
  const routed = Boolean(vertical?.funnelSlug) && data && Object.prototype.hasOwnProperty.call(data, "routed_buyer");
  const b = routed ? data.routed_buyer : null;
  const picks = routed
    // A buyer's own page that ended up with no buyer: "none" keeps that buyer's branding off the thank-you page.
    ? { firm: b?.firm_name, phone: b?.phone, slug: b?.code || vertical.funnelSlug, b: b?.code || (vertical.buyerLander ? "none" : undefined) }
    : { firm: vertical?.firmName, phone: vertical?.firmPhone, slug: vertical?.customSlug, b: vertical?.buyerCode };
  return Object.fromEntries(Object.entries(picks).filter(([, v]) => v));
}
